import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase configuration. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in .env.local.');
}

if (supabaseUrl.includes('CAB-STORE') || supabaseUrl.includes('your-project-ref')) {
  throw new Error('Invalid Supabase URL. Use the real Project URL from Supabase Project Settings > API.');
}

try {
  const projectRef = new URL(supabaseUrl).hostname.split('.')[0];
  window.localStorage.removeItem(`sb-${projectRef}-auth-token`);
} catch {
  // Storage can be unavailable in restricted browser contexts.
}

try {
  const payload = JSON.parse(window.atob(supabaseAnonKey.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
  if (payload.role === 'service_role') {
    throw new Error('A service_role key cannot be used in the browser. Rotate it and use the public anon key instead.');
  }
} catch (error) {
  if (error.message.includes('service_role')) throw error;
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
  },
});

export default supabase;
